<template>
  <div
    class="modal-mask artwork-modal bidding-increment-modal"
    @click="checkClickTarget"
    data-close-modal
  >
    <div class="modal-dialog modal-lg internet_auction-modal">
      <div class="modal-content">
        <slot name="header">
          <button
            class="bidding-increment-modal__close btn-oval btn-oval--transparent modal__close"
            data-close-modal
          >
            <span
              class="icon icon-close-big"
              data-close-modal
            />
          </button>
        </slot>
        <slot name="body">
          <div class="artwork artwork--modal internet-modal">
            <div class="container artwork__thumbs_box">
              <div class="row">
                <ArtworkImage
                  :imageSource="internetAuction.artwork.imageFullUrl"
                  :artworkName="internetAuction.artwork.name"
                  class="artwork__thumb_full col-md-12"
                />
              </div>
              <div v-if="internetAuction.artwork.attachedImages.length > 0" class="row artwork__thumb_row_attached">
                <template v-for="attached_image in internetAuction.artwork.attachedImages">
                  <ArtworkImage
                      :imageSource="attached_image.url"
                      :artworkName="internetAuction.artwork.name"
                      class="artwork__thumb_attached white-attached-container col-md-4 col-sm-6 col-6 artwork__image_attached"
                  />
                </template>
              </div>
            </div>
            <div class="artwork__details">
              <div class="row artwork__content">
                <div class="col-12 col-sm-auto">
                  <div class="headings--h2">
                    {{ internetAuction.artwork.catalogNumber }}
                  </div>
                </div>
                <AuctionContent :internetAuction="internetAuction" />
              </div>
            </div>
          </div>
        </slot>
        <div
          v-if="internetAuction.artwork.extraDescription"
          class="d-block artwork__extra-desc"
        >
          <p
            v-html="internetAuction.artwork.extraDescription"
            class="text--muted"
          >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import IsIos from '@/shared/mixins/is_ios';
  import ArtworkImage from '@/shared/components/artwork_image';
  import { INTERNET_AUCTIONS_PAGE_PARAMS } from '@/internet_auctions/consts';
  import UrlModification from '@/shared/mixins/url_modification';
  import ArtworkDetails from './artwork_details';
  import AuctionContent from './auction_content';

  export default {
    name: 'AuctionModal',
    components: {
      ArtworkImage,
      ArtworkDetails,
      AuctionContent,
    },
    props: {
      internetAuction: {
        type: Object,
      },
    },
    mixins: [IsIos, UrlModification],
    methods: {
      ...mapMutations([
        'REMOVE_ACTIVE_MODAL_INTERNET_AUCTION',
        'REMOVE_ARTWORK_QUERY',
      ]),
      checkClickTarget(event) {
        const clickedElementAttributes = event.target.attributes;

        Object.values(clickedElementAttributes).find((attribut) => {
          if (attribut.nodeName === 'data-close-modal') {
            this.closeModal();
          }
          return true;
        });
      },
      closeModal() {
        this.REMOVE_ACTIVE_MODAL_INTERNET_AUCTION();
        if (this.isIos) {
          this.$scrollTo(`#artwork_${this.internetAuction.artwork.id}`, -1);
          document.body.classList.remove('ios-fix');
        } else {
          document.body.classList.remove('modal-open');
        }
      },
    },
    mounted() {
      this.updateUrl(INTERNET_AUCTIONS_PAGE_PARAMS.artworkParam, this.internetAuction.artwork.id);
    },
    destroyed() {
      this.removeQuery([INTERNET_AUCTIONS_PAGE_PARAMS.artworkParam]);
      this.REMOVE_ARTWORK_QUERY();
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/index.vue?e04cb18e